import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../../assets/images/logo.png";
import "./style.css";
import CreditWarning from "./buycredit";
import Cookies from "js-cookie";
const Bychat = ({ showModalChat, handleModalCloseChat, data = {}, expert }) => {
  const [showCreditWarning, setShowCreditWarning] = useState(false);
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    if (data?.usercredit && data?.max) {
      if (data.usercredit < data.max) {
        setShowCreditWarning(true);
      } else {
        setShowCreditWarning(false);
      }
    }
  }, [data]);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/by-chat/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return;
  }
  const userInfoCookie = localStorage.getItem(process.env.REACT_APP_USER_INFO);

  const userInfo = userInfoCookie ? JSON.parse(userInfoCookie) : null;

  const account_id = userInfo?.user_id;
  const expert_id = expert.private_chat_id;
  return (
    <Modal
      show={showModalChat}
      onHide={handleModalCloseChat}
      dialogClassName="custom-modal-dialog"
      centered
    >
      <Modal.Header closeButton className="modal-header-gradient">
        <img
          src={logo}
          alt="Logo"
          style={{ height: "12px", marginRight: "auto" }}
        />
      </Modal.Header>

      <Modal.Body className="p-0">
        <div className="d-flex align-items-center justify-content-center p-3 body-section-gradient">
          <div className="position-relative me-3">
            <img
              src={expert.image}
              alt={expert.nickname}
              className="rounded-circle profile-image"
            />
            <span
              className={`position-absolute status-indicator ${
                expert.status === "available"
                  ? "status-available"
                  : "status-unavailable"
              }`}
            />
          </div>
          <div>
            <p className="mb-0 consultant-header">
              {languageData.header.title}
            </p>
            <p className="mb-0 consultant-name">
              {expert?.nickname.toUpperCase()}
            </p>
          </div>
        </div>
        <div className="text-center pt-4 mx-auto w-100 w-md-75 w-lg-50">
          <p className="mb-2 d-inline fs-14 text-center text-dark">
            {languageData.content.title} {expert?.nickname.toUpperCase()}{" "}
            {languageData.content.subtitle}
            <br />
            {languageData.content.subtitle2}
          </p>
        </div>

        <div className="text-center mb-4 mt-5">
          <div className="d-flex justify-content-center align-items-center mb-2">
            <button data-interaction="chat_modal_button"
              className="btn btn-primary fs-16 mb-2"
              style={{ width: "40%" }}
              onClick={() => {
                let url = `${process.env.REACT_APP_CHAT_URL}?source=gocc&contact_account=${account_id}`;
                if (!account_id) return;
                if (expert_id) {
                  url += `&expert_id=${expert_id}`;
                }

                // window.location.href = url;
                window.open(url, "_blank");
              }}
            >
              {languageData.content.button} {expert.nickname}
            </button>
          </div>
        </div>
        {/*   </>
        ) : (
          <>
            <CreditWarning data={data} communicationType="chat" />
          </>
        )} */}
      </Modal.Body>
    </Modal>
  );
};

export default Bychat;
